<template>
  <div class="_modals">
    <b-modal
      id="addSKU"
      ref="modalMoveOutStorage"
      centered
      hide-footer
      :title="`Move to Out Storage`"
      no-close-on-backdrop
      no-close-on-esc
      @close="resetForm()"
    >
      <div v-if="inventoryDetail" class="pdetail__border p-4">
        <div class="row p-0 mb-3">
          <div class="col-12">
            <p class="fontstyle__default mb-1">
              Outbound Date <span style="color: #c4232a">*</span>
            </p>
            <div class="input__model1group">
              <b-input-group>
                <b-form-input
                  v-model="form.outboundDate"
                  type="date"
                  name="Outbound Date"
                  v-validate="'required'"
                />
              </b-input-group>
              <p v-if="errors.has('Outbound Date')" class="fontstyle__errormsg">
                {{ errors.first('Outbound Date') }}
              </p>
            </div>
          </div>
        </div>
        <div class="row p-0 mb-3">
          <div class="col-12">
            <p class="fontstyle__default mb-1">Notes (Optional)</p>
            <div class="input__textareacount">
              <textarea
                v-model="form.notes"
                placeholder="Type your notes"
                name="Note"
                rows="3"
              />
            </div>
          </div>
        </div>
        <div id="modalUploadDocument">
          <p class="fontstyle__default">Upload Document</p>
          <div
            class="input__dragdrop"
            v-if="
              !Boolean(form.fileDocument) && form.fileDocumentUpload.length < 10
            "
            id="errorfile"
          >
            <b-form-file
              v-model="form.fileDocument"
              name="fileDocumentShipment"
              :multiple="true"
              drop-placeholder="Drop file here..."
            >
              <template slot="placeholder">
                <img
                  class="input__dragdrop--img"
                  src="@/assets/image/icon/icon-upload-drag-drop.svg"
                  alt=""
                />
                <p class="mt-3">
                  Drag your file here or
                  <u style="color: #1e3354; font-weight: 700">Choose file</u>
                </p>
                <p style="font-size: 10px; padding-bottom: 32px;">
                  Allowed file type : doc, docx, xlsx, pdf (max. 10 MB)
                </p>
              </template>
            </b-form-file>
            <p class="textinfo text-left">{{ errorForm.fileInput }}</p>
          </div>
          <div v-if="!statusForm">
            <div
              class="input__dragdrop text-center p-4"
              style="border: 1px dashed rgb(196, 35, 42)"
            >
              <img
                class="input__dragdrop--img"
                src="@/assets/image/icon/icon-upload-drag-dropred.svg"
                alt=""
              />
              <p
                class="mt-3"
                style="
                  color: rgb(196, 35, 42);
                  font-style: normal;
                  font-weight: normal;
                  font-size: 10px;
                "
              >
                {{ messageFileError }} <br />
                <u
                  style="color: #1e3354; font-weight: 700"
                  @click="resetModalUploadDoc()"
                  >Choose file</u
                >
              </p>
            </div>
          </div>
          <div
            v-if="
              !progressBar.status &&
                showProgressText(progressBar.value, progressBar.max) <= 100
            "
            class="mb-4"
          >
            <p class="mb-2 fontstyle__default">Uploading</p>
            <b-progress :max="progressBar.max" show-progress>
              <b-progress-bar
                :value="progressBar.value"
                :label="
                  `${showProgressText(
                    progressBar.value,
                    progressBar.max
                  )}% Uploading...`
                "
              ></b-progress-bar>
            </b-progress>
            <p class="fontstyle__default">
              Uploading your file, please wait...
            </p>
          </div>
          <div v-if="!isLoadingProgress">
            <div
              v-if="
                form.fileDocumentUpload && form.fileDocumentUpload.length > 0
              "
            >
              <div
                class="d-flex justify-content-between align-items-center stylefile p-2 mt-2"
                v-for="(file, index) in form.fileDocumentUpload"
                :key="index"
              >
                <div class="d-flex align-items-center">
                  <img
                    class="mr-2"
                    src="@/assets/image/icon/icon-file.svg"
                    alt=""
                  />
                  <p
                    class="fontstyle__default"
                    style="color: var(--primary-400, #1d3354)"
                  >
                    <b style="word-break: break-all">{{
                      file ? file.name : ''
                    }}</b>
                  </p>
                </div>
                <div>
                  <img
                    src="@/assets/image/icon/icon-tresh-red.svg"
                    style="cursor: pointer"
                    @click="removeContainer(index, file)"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <p class="global__texterror text-left py-1">
          *Please upload these documents : Master BL, Packing list, Invoice, BC
          1.1 manifest, COO (optional)
        </p>
        <!-- list sku -->
        <div class="text-blue text-base font-semibold pt-4 pb-3">
          List SKU
        </div>
        <div class="d-flex align-items-center mb-3">
          <div class="col-6 p-0">SKU ID - Product Name</div>
          <div class="col-5">Out Storage Quantity</div>
          <div class="col-1"></div>
        </div>
        <div
          v-for="(item, index) in form.sku"
          :key="item.id"
          class="d-flex align-items-center mb-3"
        >
          <div class="col-6 p-0">
            <div
              class="text-0e0e0e text-sm font-semibold bg-e5eaed p-2 rounded-md"
            >
              {{ item.skuId }} - {{ item.productInformation }}
            </div>
          </div>
          <div class="col-5">
            <div class="input__model1group">
              <b-input-group>
                <b-form-input
                  v-model="item.outboundQuantity"
                  type="number"
                  :name="`Out Storage Quantity ${index}`"
                  v-validate="{
                    required: true,
                    min_value: 1
                  }"
                  trim
                  min="0"
                  @keypress="avoidMinus($event)"
                  @paste="avoidPasteMinus($event)"
                />
              </b-input-group>
              <span
                v-if="
                  item.outboundQuantity &&
                    item.outboundQuantity > item.instorageQuantity
                "
                class="fontstyle__errormsg"
              >
                Out Storage Quantity could not be larger than In Storage
                Quantity
              </span>
              <p
                v-if="errors.has(`Out Storage Quantity ${index}`)"
                class="fontstyle__errormsg"
              >
                {{ errors.first(`Out Storage Quantity ${index}`) }}
              </p>
            </div>
          </div>
          <div class="col-1">
            <div>
              <img
                src="@/assets/image/icon/icon-tresh-red.svg"
                style="cursor: pointer"
                @click="removeSku(item)"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-end mt-2">
        <button
          class="button__bluecorporite px-4 py-2"
          :disabled="
            (!progressBar.status &&
              showProgressText(progressBar.value, progressBar.max) <= 100) ||
              disabledRequestToMove
          "
          @click="submit"
          style="border-radius: 4px !important; font-size: 12px !important"
        >
          Process
        </button>
      </div>
    </b-modal>
    <b-modal
      ref="confirmInbound"
      id="modalConfirmInbound"
      centered
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
      title="Confirmation"
      @close="confirmNo()"
    >
      <div class="__body text-center">
        <p class="mb-2">
          Are you sure that you want to request for move this inventory to the
          out storage section?
        </p>
        <div class="d-flex justify-content-center mt-4">
          <button class="button__redcorporite mr-3" @click="confirmNo()">
            No
          </button>
          <button class="button__bluecorporite" @click="processData()">
            <div
              v-if="isLoadingMoveInventory"
              class="spinner-border"
              role="status"
              style="width: 1rem !important;height: 1rem !important;"
            >
              <span class="sr-only">Loading...</span>
            </div>
            <span v-else>Yes</span>
          </button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'

export default {
  name: 'MoveOutStorageModal',
  props: {
    viewModal: Boolean,
    selectedSku: {
      type: Array,
      default: () => []
    }
  },
  components: {},
  computed: {
    ...mapGetters({
      inventoryDetail: 'warehouse/inventoryDetail',
      isLoadingInventoryDetail: 'warehouse/isLoadingInventoryDetail',

      moveInventory: 'warehouse/moveInventory',
      isLoadingMoveInventory: 'warehouse/isLoadingMoveInventory',
      errorMoveInventory: 'warehouse/errorMoveInventory'
    }),
    formFile() {
      return this.form.fileDocument
    },
    disabledRequestToMove() {
      return (
        this.form.sku.length == 0 ||
        this.form.sku.some(
          el =>
            !el.outboundQuantity ||
            el.outboundQuantity == 0 ||
            el.outboundQuantity > el.instorageQuantity
        )
      )
    }
  },
  data() {
    return {
      statusForm: true,
      isLoadingProgress: true,
      form: {
        outboundDate: '',
        notes: '',
        sku: this.selectedSku,
        fileDocument: null,
        fileDocumentUpload: [],
        fileDocumentRequestDeleted: []
      },
      progressBar: {
        value: 0,
        max: 0,
        status: false
      },
      message: '',
      messageFileError: '',
      errorForm: {
        fileInput: ''
      }
    }
  },
  watch: {
    viewModal(value) {
      if (value) {
        this.form.sku = this.selectedSku
        this.$refs.modalMoveOutStorage.show()
      }
    },
    formFile(data) {
      if (data && data.length > 0) {
        // eslint-disable-next-line array-callback-return
        data.filter(item => {
          this.messageFileError = ''
          if (item.size > 10485760) {
            this.statusForm = false
            this.messageFileError =
              'Sorry, your file is too big. Please upload file with maximum 10 MB.'
            this.progressBar.status = true
            return
          }
          if (
            item.type !== 'application/pdf' &&
            item.type !==
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' &&
            item.type !== 'application/msword' &&
            item.type !==
              'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
          ) {
            this.statusForm = false
            this.messageFileError =
              'Sorry, you are not allowed to upload this file type'
            this.progressBar.status = true
            return
          }
          this.progressBar.max += item.size
          this.form.fileDocumentUpload.push(item)
          if (
            this.form.fileDocumentUpload &&
            this.form.fileDocumentUpload.length > 10
          ) {
            // eslint-disable-next-line array-callback-return, no-shadow
            this.form.fileDocumentUpload.filter((data, i) => {
              if (i > 9) {
                this.removeContainer(i)
              }
            })
          }
        })
        if (this.statusForm) {
          this.startTimer()
        }
      }
    }
  },
  methods: {
    onFileChangeEdit(e) {
      const al = this
      const files = e.target.files || e.dataTransfer.files
      if (files[0].size < 5242880) {
        this.message = ''
        // eslint-disable-next-line no-plusplus
        for (let index = 0; index < files.length; index++) {
          const reader = new FileReader()
          // eslint-disable-next-line func-names
          reader.onload = function(event) {
            const imageUrl = event.target.result
            al.form.pictureName = imageUrl
          }
          reader.readAsDataURL(files[index])
        }
      } else {
        this.form.picture = null
        this.message = 'Your file exceeded maximum requirement file'
      }
    },
    startTimer() {
      let byte = 102400 // 100 kb to byte
      const vm = this.progressBar
      vm.status = false
      this.isLoadingProgress = true
      const timer = setInterval(() => {
        // set kecepatan progress
        if (vm.max > 1048576) {
          // 1MB
          byte = 1048576
        } else if (vm.max < 102400) {
          byte = 10240 // 10KB
        }
        // kalo ada ekor angka yang < byte, langsung nambain ekornya biar progress 100%
        if (vm.value + byte > vm.max) {
          vm.value += vm.max % byte
        } else {
          vm.value += byte
        }
        if (vm.value >= vm.max) {
          clearInterval(timer)
          vm.status = true
          this.isLoadingProgress = false
          this.resetModalUploadDoc()
        }
      }, 1000)
    },
    removeContainer(index, data) {
      this.form.fileDocumentUpload.splice(index, 1)
      if (data && data.id) {
        this.form.fileDocumentRequestDeleted.push(data.id)
      }
    },
    resetModalUploadDoc() {
      this.form.fileDocument = null
      this.statusForm = true
      this.progressBar = {
        value: 0,
        max: 0,
        status: false
      }
      this.errorForm = {
        fileInput: ''
      }
    },
    resetForm() {
      this.form = {
        outboundDate: '',
        notes: '',
        sku: [],
        fileDocument: null,
        fileDocumentUpload: []
      }
      this.message = ''
      this.resetModalUploadDoc()
      this.$emit('update:viewModal', false)
    },
    showProgressText(start, max) {
      return ((start / max) * 100).toFixed(0)
    },
    avoidMinus(e) {
      // eslint-disable-next-line no-restricted-globals
      const key = !isNaN(e.charCode) ? e.charCode : e.keyCode
      if (!this.keyAllowed(key)) e.preventDefault()
    },
    avoidPasteMinus(e) {
      const pasteData = e.clipboardData.getData('text/plain')
      if (pasteData.match(/[^0-9]/)) e.preventDefault()
    },
    keyAllowed(key) {
      const keys = [
        8,
        9,
        13,
        16,
        17,
        18,
        19,
        20,
        27,
        46,
        48,
        49,
        50,
        51,
        52,
        53,
        54,
        55,
        56,
        57,
        91,
        92,
        93
      ]
      if (key && keys.indexOf(key) === -1) return false
      return true
    },
    formatMaxLenght10(e) {
      return String(e).substring(0, 10)
    },
    submit() {
      if (!this.message) {
        this.$validator.validateAll().then(result => {
          if (result) {
            this.$refs.modalMoveOutStorage.hide()
            this.$refs.confirmInbound.show()
          }
        })
      }
    },
    confirmNo() {
      this.$refs.confirmInbound.hide()
      this.$refs.modalMoveOutStorage.show()
    },
    async processData() {
      const formData = new FormData()
      formData.set('outboundDate', this.form.outboundDate)
      formData.set('notes', this.form.notes)
      if (this.form.fileDocumentUpload.length > 0) {
        this.form.fileDocumentUpload.forEach(item => {
          formData.append('fileDocument', item)
        })
      }
      if (this.form.sku.length > 0) {
        const skuMapped = this.form.sku.map(el => {
          return {
            skuId: el.id,
            outboundQuantity: Number(el.outboundQuantity)
          }
        })
        formData.append('sku', JSON.stringify(skuMapped))
      } else {
        formData.append('sku', null)
      }
      await this.$store
        .dispatch('warehouse/MOVE_INVENTORY', {
          id: this.$route.params.id,
          formData
        })
        .then(() => {
          if (!this.errorMoveInventory) {
            this.$emit('handle-result', true)
          } else {
            this.$emit('handle-result', false)
          }
          this.$refs.modalMoveOutStorage.hide()
          this.$refs.confirmInbound.hide()
        })
        .catch(() => {
          this.$emit('handle-result', false)
          this.$refs.modalMoveOutStorage.hide()
          this.$refs.confirmInbound.hide()
        })
        .finally(() => {
          this.resetForm()
        })
    },
    getDate(date) {
      return moment(date).format('YYYY-MM-DD')
    },
    removeSku(item) {
      this.form.sku = this.form.sku.filter(el => el.id != item.id)
      this.$emit('update:selectedSku', this.form.sku)
    }
  }
}
</script>

<style lang="scss">
.pdetail {
  &__header {
    font-size: 16px;
    font-weight: 700;
    color: #1d3354;
    @media only screen and (max-width: 1536px) {
      margin: 1.5rem 0rem 0.5rem 0rem !important;
    }
  }
  &__paragraph1 {
    font-size: 14px;
    font-weight: 400;
    color: #6e6e6e;
  }
  &__paragraph2 {
    font-size: 14px;
    font-weight: 600;
    color: #1d3354;
  }
  &__border {
    border: 1px solid #dadee2;
    border-radius: 8px;
    @media only screen and (min-width: 1536px) {
      padding: 1.5rem;
    }
    padding: 1rem;
    column-gap: 1rem;
  }
  &__buttonwhite {
    width: 185px;
    height: 36px;
    color: #1d3354;
    border: 1px solid #1d3354;
    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.12);
    border-radius: 4px;
    background: #ffffff;
    font-weight: 600;
    font-size: 14px;
    line-height: 24px;
    letter-spacing: -0.011em;
  }
  &__buttonred {
    width: 100px;
    height: 36px;
    color: #c4232a;
    border: 1px solid #c4232a;
    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.12);
    border-radius: 4px;
    background: #ffffff;
    font-weight: 600;
    font-size: 14px;
    line-height: 24px;
    letter-spacing: -0.011em;
  }
}
.input__attachblue .custom-file-input ~ .custom-file-label[data-browse]::after,
.form-file-text {
  font-size: 12px;
}
#modalUploadDocument .form-file-text {
  margin-top: -45px;
}
#uploadPicture .b-form-file {
  width: 109px;
}
#uploadPicture .custom-file-label {
  padding: 0.4rem 0.25rem 1.4rem 6.25rem !important;
}
.customplaceholder {
  ::placeholder {
    color: #9ea1a4 !important;
  }

  @media only screen and (min-width: 1536px) {
    width: 100%;
  }

  width: 73%;
}
.stylefile {
  border-radius: 4px;
  border: 1px dashed var(--neutral-500, #b6b6b6);
  background: var(--neutral-20, #ecf1f5);
}
.input__moneydefault input,
.input__moneydefault--text {
  border: 1px solid #ced4d9;
  color: #495057;
  border-color: #ced4d9;
}
</style>



// WEBPACK FOOTER //
// src/components/global/modals/MoveOutStorageModal.vue